import {AutoComplete, Form} from "rsuite";
import React, {useEffect, useState} from "react";
import {getCerts} from "../../../../../service/dataService";

const CertificationsSearchForm = () => {

    const [certs, setCerts] = useState([]);

    useEffect(() => {
        getCerts().then((data) => {
                // format the data into InputPicker format for now
                setCerts(data.map(ele => ({label: ele.certName, value: ele.certName})));
            }
        );
    }, []);

    return (
        <Form.Group>
            <Form.ControlLabel>Certification Name</Form.ControlLabel>
            <Form.Control name="certName"
                          accepter={AutoComplete}
                          data={certs}
                          style={{width: 400}}
            />
        </Form.Group>
    );
};

export default CertificationsSearchForm;